<br>
<br>
<br>

<div class="container">
  <br />
  <div class="col-md-6 col-md-offset-3" id="login">
    <div class="panel panel-default">
      <div class="panel-heading">
        <a class="centrado"><img src="./assets/img/cnsf_azul.jpeg"></a>
        <br><br><br>
        <label class="panel-title centrado">
          Restablecer contraseña</label>
      </div>
      <br>
      <div class="row">
        <form [formGroup]="changeForm" #login="ngForm" (ngSubmit)="submitChange()" >
          <div class="col-md-7 col-md-offset-3" id="login">
            
              <div class="form-group">
                <label class="user"> Correo </label>
                <div class="input-group">
                  <span class="input-group-addon" id="iconn"> <i class="glyphicon glyphicon-user"></i></span>
                  <input type="text" class="form-control" [(ngModel)]="actuario.usuario" name="correo" id="correo"
                  placeholder="Ingrese Correo Registrado" autocomplete="off" formControlName="correo"/>
                  
                </div>
                <div class="alert alert-danger" *ngIf="correo.invalid && (correo.dirty || correo.touched)">
                    <div class="container-error-message" *ngIf="correo.errors.required">
                        El campo <strong>Correo Electrónico</strong> es requerido
                    </div>
                    <div class="container-error-message" *ngIf="correo.errors.email">
                        El formato del <strong>Correo Electrónico</strong> no es valido
                    </div>
                </div>
              </div>         
          
            <div class="form-group">
              <label class="user"> Contraseña Nueva </label>
              <div class="input-group">
                <span class="input-group-addon" id="iconn1"> <i class="glyphicon glyphicon-lock"></i></span>
                <input type="text" class="form-control" value="" name="ingresoNuevo" id="ingresoNuevo"
                  placeholder="Ingrese Contraseña Nueva" autocomplete="off" formControlName="ingresoNuevo" maxlength="17"/>
                  
              </div>
              <div class="alert alert-danger" *ngIf="ingresoNuevo.invalid && (ingresoNuevo.dirty || ingresoNuevo.touched)">
                <div class="container-error-message" *ngIf="ingresoNuevo.errors.required">
                    El campo <strong>Correo Electrónico</strong> es requerido
                </div>
                
                <div class="container-error-message" *ngIf="(ingresoNuevo.dirty || ingresoNuevo.touched) &&
                ingresoNuevo.invalid && ingresoNuevo.errors.pattern">
                Una contraseña segura debe: <br>
                <strong>*</strong> Tener mínimo 8 caracteres <br>
                <strong>*</strong> Al menos una letra mayúscula<br>
                <strong>*</strong> Al menos una letra minúscula<br>
                <strong>*</strong> Al menos un número<br>
                <strong>*</strong> Al menos uno de los siguientes caracteres especiales <strong>@,$,&</strong><br><br>
                No se aceptan caracteres especiales diferentes de los indicados
                </div>
            </div>
            </div>
          
          
          
          
            <div class="form-group">
              <label class="user"> Confirma Contraseña </label>
              <div class="input-group">
                <span class="input-group-addon" id="iconn1"> <i class="glyphicon glyphicon-lock"></i></span>
                <input type="text" class="form-control" value="" name="confirmaIngreso" id="confirmaIngreso"
                  placeholder="Ingrese Confirmación" autocomplete="off" formControlName="confirmaIngreso" maxlength="17"/>
              </div>
              <div class="alert alert-danger" *ngIf="confirmaIngreso.invalid && (confirmaIngreso.dirty || confirmaIngreso.touched)">
                <div class="container-error-message" *ngIf="confirmaIngreso.errors.required">
                    El campo <strong>Confirma Contraseña</strong> es requerido
                </div>
                <div class="container-error-message" *ngIf="confirmaIngreso.errors.mustMatch">
                    No coinciden el campo <strong>Password</strong> y <strong>Confirmación</strong> 
                </div>
            </div>
            </div>
            
          
            <div class="form-group">
              <button id="btnSubmit" mat-raised-button type="submit" class="btn btn-primary my-2" [disabled]="!login.form.valid">Proceder</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>
</div>

<br>
<br>
<br>
